const translations = {
  "en": {
    "I want to set a new goal": "I want to set a new goal"
  },
  "zh-tw": {
    "I want to set a new goal": "我想設定新目標"
  }
};

export default translations;
